import { FC, ReactNode } from 'react';

import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { commonTheme } from 'portfolio3/styles/theme';
import { SxStyles } from 'types';
import { mergeSx } from 'utils';

import * as styles from './styles';

interface IDiagnosticCardProps {
  title: string;
  subtitle: string;
  date: string;
  resultElement: ReactNode;
  // тоггл для настроек видимости
  topAddon?: ReactNode;
  // раскрывающаяся часть
  bottomAddon?: ReactNode;
  sx?: SxStyles;
}

const DiagnosticCard: FC<IDiagnosticCardProps> = ({
  title,
  subtitle,
  date,
  resultElement,
  topAddon,
  bottomAddon,
  sx,
}) => {
  const isSmallScreen = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  const desktopMainElement = (
    <Box display="grid">
      <Stack gap="4px">
        <Typography variant="Paragraph MD/Semi Bold">{title}</Typography>
        <Typography variant="Paragraph MD/Regular">{subtitle}</Typography>
      </Stack>
      <Typography variant="Paragraph MD/Regular" alignSelf="end">
        {date}
      </Typography>
    </Box>
  );

  const mobileMainElement = (
    <>
      <Stack gap="8px">
        <Typography variant="Paragraph MD/Bold">{title}</Typography>
        <Typography variant="Paragraph MD/Regular">{subtitle}</Typography>
        <Typography variant="Paragraph MD/Regular">{date}</Typography>
      </Stack>
    </>
  );

  return (
    <Box className="diagnostic-card" sx={mergeSx(styles.root, sx)}>
      {topAddon}
      <Box className="diagnostic-card__main" sx={styles.mainContainer}>
        {isSmallScreen ? mobileMainElement : desktopMainElement}
        {resultElement}
      </Box>
      {bottomAddon}
    </Box>
  );
};

export default DiagnosticCard;
